import { useCallback, useMemo } from 'react'
import useShortcuts from '../../hooks/useShortcuts'
import { useDispatch } from 'react-redux'
import { ShortcutsCategories } from './Shortcuts.types'
import { setSecuritySearchOpen } from '../../reducer/home.reducer'
import AnalyticsManager from '../../analytics/AnalyticsManager'

const SecuritySearchShortcutsRegister = () => {
    const dispatch = useDispatch()

    const openDialog = useCallback(() => {
        AnalyticsManager.logEvent('Security Search Opened', { source: 'keyboard' })
        dispatch(setSecuritySearchOpen({ open: true, key: undefined, isExpression: false }))
    }, [])

    const alphabetKeys = useMemo(() => {
        return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').reduce((acc, key) => {
            acc[key] = openDialog
            return acc
        }, {} as { [key: string]: () => void })
    }, [openDialog])

    useShortcuts(ShortcutsCategories.SECURITY_SEARCH, alphabetKeys)
    return null
}

export default SecuritySearchShortcutsRegister